import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';
import { StaffMemberFragment, StaffMemberDetailFragment } from './StaffMemberFragment';

const CreateStaffMemberMutation = graphql.persisted(
  "CreateStaffMember",
  graphql(`
    mutation CreateStaffMember($input: CreateStaffMemberInput!) {
      createStaffMember(input: $input) {
        staffMember { ...StaffMemberFragment }
        userErrors { message path }
      }
    }
  `, [StaffMemberFragment])
);

const UpdateStaffMemberMutation = graphql.persisted(
  "UpdateStaffMember",
  graphql(`
    mutation UpdateStaffMember($input: UpdateStaffMemberInput!) {
      updateStaffMember(input: $input) {
        staffMember { ...StaffMemberDetailFragment }
        userErrors { message path }
      }
    }
  `, [StaffMemberDetailFragment])
);

const DeactivateStaffMemberMutation = graphql.persisted(
  "DeactivateStaffMember",
  graphql(`
    mutation DeactivateStaffMember($input: DeactivateStaffMemberInput!) {
      deactivateStaffMember(input: $input) {
        staffMember { ...StaffMemberDetailFragment }
        userErrors { message path }
      }
    }
  `, [StaffMemberDetailFragment])
);

const ReactivateStaffMemberMutation = graphql.persisted(
  "ReactivateStaffMember",
  graphql(`
    mutation ReactivateStaffMember($input: ReactivateStaffMemberInput!) {
      reactivateStaffMember(input: $input) {
        staffMember { ...StaffMemberDetailFragment }
        userErrors { message path }
      }
    }
  `, [StaffMemberDetailFragment])
);

const DeleteStaffMemberMutation = graphql.persisted(
  "DeleteStaffMember",
  graphql(`
    mutation DeleteStaffMember($input: DeleteStaffMemberInput!) {
      deleteStaffMember(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const InviteStaffMemberMutation = graphql.persisted(
  "InviteStaffMember",
  graphql(`
    mutation InviteStaffMember($input: InviteStaffMemberInput!) {
      inviteStaffMember(input: $input) {
        staffMember { ...StaffMemberDetailFragment }
        sentEmail
        userErrors { message path }
      }
    }
  `, [StaffMemberDetailFragment])
);

export {
  CreateStaffMemberMutation,
  UpdateStaffMemberMutation,
  DeactivateStaffMemberMutation,
  ReactivateStaffMemberMutation,
  DeleteStaffMemberMutation,
  InviteStaffMemberMutation,
};

export function useCreateStaffMember() { return useMutation(CreateStaffMemberMutation); }
export function useUpdateStaffMember() { return useMutation(UpdateStaffMemberMutation); }
export function useDeactivateStaffMember() { return useMutation(DeactivateStaffMemberMutation); }
export function useReactivateStaffMember() { return useMutation(ReactivateStaffMemberMutation); }
export function useDeleteStaffMember() { return useMutation(DeleteStaffMemberMutation); }
export function useInviteStaffMember() { return useMutation(InviteStaffMemberMutation); }
